// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__3gN5n","breakthrough":"style_breakthrough__1T-jM","year":"style_year__1SYlH","minYear":"style_minYear___sqFU","maxYear":"style_maxYear__3Su1F"};